import * as ViewletTitleBarMenuBar from './ViewletTitleBarMenuBar.js'

// prettier-ignore
export const Commands = {
  'TitleBarMenuBar.closeMenu': ViewletTitleBarMenuBar.closeMenu,
  'TitleBarMenuBar.focus': ViewletTitleBarMenuBar.focus,
  'TitleBarMenuBar.focusFirst': ViewletTitleBarMenuBar.focusFirst,
  'TitleBarMenuBar.focusIndex': ViewletTitleBarMenuBar.focusIndex,
  'TitleBarMenuBar.focusLast': ViewletTitleBarMenuBar.focusLast,
  'TitleBarMenuBar.focusNext': ViewletTitleBarMenuBar.focusNext,
  'TitleBarMenuBar.focusPrevious': ViewletTitleBarMenuBar.focusPrevious,
  'TitleBarMenuBar.handleKeyArrowDown': ViewletTitleBarMenuBar.handleKeyArrowDown,
  'TitleBarMenuBar.handleKeyArrowLeft': ViewletTitleBarMenuBar.handleKeyArrowLeft,
  'TitleBarMenuBar.handleKeyArrowRight': ViewletTitleBarMenuBar.handleKeyArrowRight,
  'TitleBarMenuBar.handleKeyArrowUp': ViewletTitleBarMenuBar.handleKeyArrowUp,
  'TitleBarMenuBar.handleKeyEnd': ViewletTitleBarMenuBar.handleKeyEnd,
  'TitleBarMenuBar.handleKeyEnter': ViewletTitleBarMenuBar.handleKeyEnter,
  'TitleBarMenuBar.handleKeyEscape': ViewletTitleBarMenuBar.handleKeyEscape,
  'TitleBarMenuBar.handleKeyHome': ViewletTitleBarMenuBar.handleKeyHome,
  'TitleBarMenuBar.handleKeySpace': ViewletTitleBarMenuBar.handleKeySpace,
  'TitleBarMenuBar.handleMenuMouseDown': ViewletTitleBarMenuBar.handleMenuMouseDown,
  'TitleBarMenuBar.handleMenuMouseOver': ViewletTitleBarMenuBar.handleMenuMouseOver,
  'TitleBarMenuBar.handleMouseOver': ViewletTitleBarMenuBar.handleMouseOver,
  'TitleBarMenuBar.toggleIndex': ViewletTitleBarMenuBar.toggleIndex,
  'TitleBarMenuBar.toggleMenu': ViewletTitleBarMenuBar.toggleMenu,
}

export * from './ViewletTitleBarMenuBar.js'
